/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Heatingtemperature1Inputs */



/**
* | output |
* | --- |
* | "Heating temperature" |
*
* @param {Ahu_History_Key_Heatingtemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_heatingtemperature1 = /** @type {((inputs?: Ahu_History_Key_Heatingtemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Heatingtemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating temperature")
	return /** @type {LocalizedString} */ ("Température de chauffe")
});
export { ahu_history_key_heatingtemperature1 as "ahu_history_key_heatingTemperature" }